module.exports = __webpack_public_path__ + "static/media/twB.19acf5b6.png";